export const getters = {
    /** 身份证上传页面相关数据 **/
    getHolderIdCardInfo: (store) => store.insuredIdCardUploadInfo.holder,
    getInsurersIdCardInfo: (store, getters) => store.insuredIdCardUploadInfo.insurers,

    /** 产品状态 **/
    getProductCode: (store, getters) => store.productInfo.productCode,
    getProductAllPdfFile: (store, getters) => store.productInfo.allPdfFile,
    getProductInsuranceScope: (store, getters) => store.productInfo.insuranceScope,

    /** 投保数据 **/
    getTimeLimit: (store,getters) => store.insureInfo.timeLimit,
    getBankInfo : (store,getters) => store.insureInfo.bankInfo,
    getInsureInsuredInfo: (store, getters) => store.insureInfo.insuredInfo,
    getInsureHolderInfo: (store, getters) => store.insureInfo.holderInfo,
    getConfirmSubmitId: (store, getters) => store.insureInfo.confirmSubmitId,
    getInsurePrice: (store, getters) => store.insureInfo.price,
    getInsureTotalPrice: (store, getters) => store.insureInfo.totalPrice,
    getOrderProcessUploadImage : (store, getters) => store.OrderProcessUploadInfo,
};



// WEBPACK FOOTER //
// ./src/vuex/getters.js